export var bluesuedeshoes = '#0071C4';
export var plum = '#650360';
export var white = '#FFF';
export var defaultFill = bluesuedeshoes;
//# sourceMappingURL=constants.js.map